import { AnyAction } from 'redux';
import { ActionTypes, IAsgState } from './types/state.types';

const initialState: IAsgState = {
  list: [],
  members: {},
  loading: false,
  failed: false,
};

const asgReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IAsgState = initialState,
  { type, payload }: AnyAction,
): IAsgState => {
  switch (type) {
    case ActionTypes.SET_LIST:
      return { ...state, list: payload };
    case ActionTypes.SET_MEMBERS:
      return { ...state, members: payload };
    case ActionTypes.SET_LOADING:
      return { ...state, loading: payload };
    case ActionTypes.SET_FAILED:
      return { ...state, failed: payload };
    default:
      return state;
  }
};

export default asgReducer;
